import { getRequestTransportErrorMessage } from '#/utils/requestError';

/**
 * inventory-stock API 錯誤文案（含 label print／split）。
 * 優先後端 `message`；已知 code 可補中文 fallback。
 */
export function getInventoryStockApiErrorMessage(
  error,
  fallback = '操作失敗，請稍後再試',
) {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'PRINTER_EXECUTE_FAILED') {
    return data?.message || '印表機執行失敗，請稍後再試';
  }

  if (code === 'INVENTORY_STOCK_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到庫存資料';
  }

  if (
    code === 'INVENTORY_STOCK_SPLIT_LOCKED'
    || code === 'INVENTORY_STOCK_LOCKED'
    || code === 'LOCKED'
  ) {
    return data?.message || '庫存已鎖定，無法拆分';
  }

  if (
    code === 'INVENTORY_STOCK_SPLIT_EXCEEDED'
    || code === 'INVENTORY_STOCK_QTY_EXCEEDED'
    || code === 'EXCEEDED'
  ) {
    return data?.message || '拆出數量超過來源可用量';
  }

  if (
    code === 'RESOURCE_VERSION_CONFLICT'
    || code === 'VERSION_CONFLICT'
  ) {
    return data?.message || '資料已被他人更新，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isInventoryStockVersionConflict(error) {
  const code = error?.response?.data?.code;
  return code === 'RESOURCE_VERSION_CONFLICT' || code === 'VERSION_CONFLICT';
}
